import { observer } from "owa-mobx-react";
import React from "react";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { type FolderForestNodeType } from "owa-favorites-types";
import folderStore from "owa-folders";
import { getMailFavoritesViewState } from "owa-mail-favorites-store";
import { setContextMenuStateMutator } from "owa-mail-favorites-store/lib/actions/favoritesContextMenu";
import publicFolderFavoriteStore from "owa-public-folder-favorite/lib/store/publicFolderFavoriteStore";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import { FavoriteNodeContextMenu, FavoritesRootContextMenu } from "../lazyFunctions";

/**
 * Single, always-mounted host for favorites context menus. It is rendered at the mail module
 * level so menus opened from the favorites side rail still show when the folder pane (or the
 * Favorites section within it) is not mounted.
 */
const FavoritesContextMenuHost: React.FunctionComponent<{}> = observer(function FavoritesContextMenuHost() {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const contextMenuState = getMailFavoritesViewState(accountKey)?.contextMenuState;
    
    const onContextMenuDismissed = React.useCallback(() => {
        setContextMenuStateMutator(accountKey, null);
    }, [accountKey]);
    
    if (!contextMenuState) {
        return null;
    }
    
    if (contextMenuState.showRootMenu) {
        return (<FavoritesRootContextMenu anchorPoint={contextMenuState.anchor} onDismiss={onContextMenuDismissed} mailboxInfo={mailboxInfo}/>);
    }
    
    let folder;
    if (contextMenuState.folderId) {
        if (contextMenuState.nodeType == 5) {
            folder = publicFolderFavoriteStore().folderTable.get(contextMenuState.folderId);
        }
        else {
            folder = folderStore().folderTable.get(contextMenuState.folderId);
        }
    }
    
    return (<FavoriteNodeContextMenu anchorPoint={contextMenuState.anchor} nodeId={contextMenuState.nodeId} nodeType={contextMenuState.nodeType} folder={folder} onDismiss={onContextMenuDismissed} mailboxInfo={mailboxInfo} isPlaceholderNode={contextMenuState.isPlaceholderNode} actionSource={contextMenuState.actionSource} isNonFavoriteFolder={contextMenuState.isNonFavoriteFolder}/>);
}, "FavoritesContextMenuHost");

export default FavoritesContextMenuHost;
